import React, { FC } from "react"
import { PhotoView } from "../../models/PhotoModel"
import { calcStandardThreeColumnLayout } from "../../libs/CalcPhotoLayout"
import { FigurePhoto } from "./FigurePhoto"
import { EditablePhoto } from "./PhotoLayout"

export const ThreeRowsPhoto: FC<{ photos: PhotoView[] } & EditablePhoto> = ({
  photos,
  editable
}) => {
  const calced = calcStandardThreeColumnLayout(photos)

  const col1className = ["bl-photo__main-container"].join(" ")
  const col2className = ["bl-photo__sub-container"].join(" ")
  const col3className = ["bl-photo__sub-container"].join(" ")

  const mainPhoto = calced.col1.photo

  return (
    <div className="bl-photo">
      <div
        className={col1className}
        style={{ flexBasis: calced.col1.percent + "%" }}
      >
        <FigurePhoto
          editable={editable}
          key={mainPhoto.id}
          id={mainPhoto.id}
          url={mainPhoto.url}
          thumbnail={mainPhoto.thumbnail(800)}
          wrapped="main"
        />
      </div>
      <div
        className={col2className}
        style={{ flexBasis: calced.col2.percent + "%" }}
      >
        {calced.col2.photos.map(photo => (
          <FigurePhoto
            editable={editable}
            key={photo.id}
            id={photo.id}
            url={photo.url}
            thumbnail={photo.thumbnail(400)}
            wrapped="sub"
          />
        ))}
      </div>
      <div
        className={col3className}
        style={{ flexBasis: calced.col3.percent + "%" }}
      >
        {calced.col3.photos.map(photo => (
          <FigurePhoto
            editable={editable}
            key={photo.id}
            id={photo.id}
            url={photo.url}
            thumbnail={photo.thumbnail(400)}
            wrapped="sub"
          />
        ))}
      </div>
    </div>
  )
}
